import { gql } from "@apollo/client";

export const MESSAGES_QUERY = gql`
  query partnerMessages($partnerId: Int!) {
    partnerMessages(partnerId: $partnerId) {
      partnerId
      messages {
        messageType
        messageCode
        data
      }
    }
  }
`;
